import MircoSoftTeam from "../Assets/Images/MicrosoftTeams.png";

const AboutContent = () => {
  return (
    <div>
      <div className="max-w-[1140px] mx-auto mt-24 sm:mt-28 lg:mt-36 pt-16 sm:pt-20 lg:pt-24 p-4 sm:p-6">
        <div className="grid lg:grid-cols-2 place-items-center gap-7 md:grid-cols-1">
          <div>
            <img src={MircoSoftTeam} alt="" />
          </div>
          <div className="p-4">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold sm:leading-10 text-white">
              Why Choose <span className="text-gradient">SpaceX?</span>
            </h1>
            <h1 className="text-3xl font-bold sm:leading-10 text-white py-2">
              We Are Technical Innovators
            </h1>
            <h1 className="text-xl font-bold sm:leading-10 text-gray-300">
              Founded in 2023, Head quarters:San Jose, California
            </h1>
            <p className="py-4 text-lg text-gray-400">
              At SpaceX, we’re dedicated to propelling your business into the
              future through cutting-edge digital transformation solutions. By
              harnessing the power of state-of-the-art technologies like
              artificial intelligence and our software solutions, we don’t just
              reinvent your business – we revolutionize it. Our tailored
              software development and logistics & transport solutions are designed to
              align seamlessly with your goals, enabling you to meet the
              ever-growing demands of the modern business landscape while
              gaining a distinct competitive advantage.
              With SpaceXPakistan by your side, the possibilities are limitless as
              we pave the way for your success in the digital age.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
